<template>
    <validation-observer ref="form" v-slot="{ meta, handleSubmit }">
        <modal
            :id="modalId"
            title="Login to Kaba"
            scrollable
            ok-title="Save"
            :ok-disabled="!meta.valid || loading"
            @ok.prevent="handleSubmit(_,save)"
            @hide="hideModal"
        >
            <busy-modal :show="loading"></busy-modal>
            <b-row>
                <b-col>
                    <validation-provider name="site_name" v-slot="{ errors, handleChange }" rules="required">
                        <form-input
                            label="Site Name:"
                            v-model="values.site_name"
                            :error="errors[0]"
                            @input="handleChange"
                        ></form-input>
                    </validation-provider>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <validation-provider name="login_name" v-slot="{ errors, handleChange }" rules="required">
                        <form-input
                            label="Login Name:"
                            v-model="values.login_name"
                            :error="errors[0]"
                            @input="handleChange"
                        ></form-input>
                    </validation-provider>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <validation-provider name="password" v-slot="{ errors, handleChange }" rules="required">
                        <form-input
                            label="Password:"
                            type="password"
                            v-model="values.password"
                            :error="errors[0]"
                            @input="handleChange"
                        ></form-input>
                    </validation-provider>
                </b-col>
            </b-row>
        </modal>
    </validation-observer>
</template>

<script>
    import isEmpty from 'lodash/isEmpty';
    import API from '../../../../api';
    import { DOOR_LOCKS_KABA_ACCOUNT_LOGIN_ENDPOINT } from '../../../../endpoints';
    import { formatResponseError } from '../../../../utils/api';
    import BusyModal from '../../../generic/busy-modal/busy-modal.vue';
    import FormInput from '../../../generic/form-input/form-input.vue'
    import Modal from '../../../generic/modal/modal.vue';

    export default {
        name: 'KabaLoginModalForm',
        components: {
            BusyModal,
            FormInput,
            Modal,
        },
        props: {
            modalId: String,
        },
        data() {
            return {
                loading: false,
                values: {
                    site_name: '',
                    login_name: '',
                    password: '',
                },
            }
        },
        methods: {
            hideModal() {
                this.$bvModal.hide(this.modalId);
            },
            async save() {
                this.loading = true;

                try {
                    await API.post(DOOR_LOCKS_KABA_ACCOUNT_LOGIN_ENDPOINT(), this.values);
                    this.$emit('success-save');
                    this.$nextTick(() => {
                        this.hideModal();
                    })
                } catch (err) {
                    const { generic, fields } = formatResponseError(err);

                    if (generic) {
                       this.errorToast({text: generic})
                    }
                    if (!generic && !isEmpty(fields)) {
                        this.$refs.form.setErrors(fields);
                    }
                } finally {
                    this.loading = false;
                }
            },
        }
    }
</script>
